<template>
  <div role="main" class="orden-main-wrap">
    <div class="content-header">
      <div class="container-fluid orden-wide-container">
        <div class="row align-items-start">
          <div class="col-md-9">
            <div class="orden-head">
              <div class="orden-ref-line">
                <span class="orden-ref-link" @click="goToHome">MIS ÓRDENES</span>
                <span class="orden-ref-sep">›</span>
                <span class="orden-ref-strong">{{ ordenReferencia }}</span>
              </div>
              <h1 class="orden-title">Programas internos</h1>
            </div>
          </div>
          <div class="col-md-3">
            <h2 class="visitas-title-header visitas-title-header--desktop">Visitas</h2>
          </div>
        </div>
      </div>
    </div>

    <div class="content">
      <div class="container-fluid orden-wide-container">
        <div class="row">
          <!-- PROGRAMAS INTERNOS -->
          <div class="col-md-9">
            <div class="cot-filter-wrap mb-4">
              <div class="row g-2">
                <div class="col-md-6 col-lg-6">
                  <div class="form-group mb-0 text-left">
                    <label class="text-muted small mb-1" for="filter-client">
                      <b>Sucursal</b>
                    </label>
                    <input
                      id="filter-client"
                      type="text"
                      class="form-control"
                      placeholder="Buscar por nombre de sucursal"
                      v-model="filters.client"
                      @input="handleClientInput"
                    />
                  </div>
                </div>
                <div class="col-md-4 col-lg-4">
                  <div class="form-group mb-0 text-left">
                    <label class="text-muted small mb-1" for="filter-status">
                      <b>FASE</b>
                    </label>
                    <select
                      id="filter-status"
                      class="form-control"
                      v-model="filters.phase"
                      @change="handlePhaseInput"
                    >
                      <option value="">Todos</option>
                      <option value="0">RECOLECCION DE DOCUMENTOS</option>
                      <option value="1">REVISIÓN DE CAMPO</option>
                      <option value="2">DESCARGA DE PROGRAMA INTERNO</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-body p-0">
              <div v-if="loading" class="text-center p-4">
                <div class="spinner-border text-primary" role="status">
                  <span class="sr-only">Cargando...</span>
                </div>
                <p class="text-muted mt-2 mb-0">Cargando programas internos...</p>
              </div>
              <div v-else-if="!pam.data || pam.data.length === 0" class="text-center p-3">
                <p class="text-muted">No hay programas internos en este momento.</p>
              </div>
              <div v-else>
              <transition-group name="orders-fade" tag="div" appear>
              <div
                v-for="(pam, index) in pam.data"
                :key="pam.id || index"
                class="card card-light card-outline mb-2 shadow-sm pam-card"
                :style="orderTransitionStyle(index)"
                @click="handleClickPAM(pam.id)"
              >
                <div class="pam-card__body">
                  <div class="pam-card__block pam-card__meta text-left">
                    <h5 class="pam-card__title">{{ pam.Servicio.cliente_nombre  }}</h5>
                  </div>

                  <div class="pam-card__block pam-card__progress">
                    <div class="d-flex justify-content-between align-items-center mb-2">
                      <span class="pam-card__label">SEGUIMIENTO</span>
                      <span class="pam-card__value">
                        {{ getCumplimientoResumen(pam) }}
                      </span>
                    </div>
                    <div class="pam-card__segmented" role="progressbar" aria-valuemin="0" aria-valuemax="100">
                      <div
                        class="pam-card__segment pam-card__segment--success"
                        :style="{ width: getCumplimientoSegment(pam, 'aceptados') }"
                        title="Aceptados"
                      ></div>
                      <div
                        class="pam-card__segment pam-card__segment--review"
                        :style="{ width: getCumplimientoSegment(pam, 'revision') }"
                        title="En revisión"
                      ></div>
                      <div
                        class="pam-card__segment pam-card__segment--danger"
                        :style="{ width: getCumplimientoSegment(pam, 'rechazados') }"
                        title="Rechazados"
                      ></div>
                      <div
                        class="pam-card__segment pam-card__segment--pending"
                        :style="{ width: getCumplimientoSegment(pam, 'pendientes') }"
                        title="Pendientes"
                      ></div>
                    </div>
                    <div class="pam-card__stats">
                      <div>
                        <div class="pam-card__stat-label">OBSERVACIONES</div>
                        <div
                          class="pam-card__stat-value"
                          :class="{
                            'badge badge-warning text-dark font-weight-bold px-2 py-1': getObservacionesPendientes(pam) >= 1
                          }"
                        >
                          {{ getObservacionesTexto(pam) }}
                        </div>
                      </div>
                      <div>
                        <div class="pam-card__stat-label">DIAS TRANSCURRIDOS</div>
                        <div class="pam-card__stat-value">
                          {{ getDiasTranscurridos(pam.Servicio) }} días
                        </div>
                      </div>
                      <div>
                        <div class="pam-card__stat-label">FASE</div>
                        <div class="pam-card__stat-value">
                          {{ getFaseLabel(pam) }}
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
              </transition-group>
              </div>
              <!-- Paginación -->
              <nav>
                <ul v-if="pam.totalItems > 10" class="pagination justify-content-center">
                  <li
                    v-for="page in pam.totalPages"
                    :key="page"
                    class="page-item"
                    :class="{ 'active': Number(pam.currentPage) === page }"
                  >
                    <a class="page-link" href="#" @click.prevent="changePage(page)">{{ page }}</a>
                  </li>
                </ul>
              </nav>
            </div>
          </div>

          <!-- CURSOS -->
          <div class="col-md-3">
            <h2 class="visitas-title-header visitas-title-header--mobile">Visitas</h2>
            <div class="card-body p-0" v-if="eventos.length > 0">
              <div
                v-for="(curso, index) in eventos.filter(e => e.capacitador)"
                :key="'servicios-' + index"
                class="card card-outline mb-2 shadow-sm curso-card d-flex"
              >
                <div class="text-left p-3">
                  <div class="d-flex justify-content-between align-items-center">
                    <small class="text-muted text"><i class="fa fa-graduation-cap mr-1"></i>{{ curso.curso?.nombre }}</small>
                    <span class="badge badge-success">Curso</span>
                  </div>
                  <hr />
                  <span class="text-req"><i class="fa-solid fa-location-dot mr-1"></i>{{ curso.lugar  || 'Instalaciones de la empresa'}}</span>
                  <span class="text-req"><i class="fa fa-calendar-days mr-1"></i>{{ formatFecha(curso.start)  }}</span>
                  <span class="text-req"><i class="fa fa-clock mr-1"></i>{{ formatearRangoHoras(curso.start, curso.end) }}</span>
                  <span class="text-req"><i class="fa fa-solid fa-chalkboard-user mr-1"></i>{{ curso.capacitador.nombre }}</span>
                  <button class="btn-doc btn-success w-100" :class="[
                  descargando[index]
                    ? 'bounce-once'
                    : ''
                ]" @click="descargarInvitacion(curso, index)">
                    {{ descargando[index] == true ? 'Descargando...' : 'Descargar invitación'}}
                  </button>
                </div>
              </div>
              <div
                v-for="(curso, index) in eventos.filter(e => e.capacitador == null)"
                :key="'curso-' + index"
                class="card card-outline mb-2 shadow-sm servicio-card d-flex"
              >
                <div class="text-left p-3">
                  <div class="d-flex justify-content-between align-items-center">
                    <small class="text-muted text"><i class="fas fa-tools"></i> {{ curso.servicio }}</small>
                    <span class="badge badge-primary">Servicio</span>
                  </div>
                  <hr />
                  <span class="text-req"><i class="fa fa-calendar-days mr-1"></i>{{ formatFecha(curso.start)  }}</span>
                  <span class="text-req"><i class="fa fa-clock mr-1"></i>{{ formatearHora(curso.start) }}</span>
                </div>
              </div>
            </div>
            <div class="card-body p-0" v-else>
              <p>No hay cursos agendados</p>
            </div>
          </div>
        </div> <!-- /.row -->
      </div> <!-- /.container -->
    </div> <!-- /.content -->
    <div>
      <FlashMessage :style="{position: 'fixed', zIndex : 9999, fontSize: '18px'}"></FlashMessage>
    </div>
  </div>
</template>

<script>
import axiosInstance from '../../services/axiosInstance';
import debounce from 'lodash.debounce';

export default{
  name: 'OrdenDetalle', 
  data(){
    return{
      pam: {
        data: [],
        totalItems: 0,
        totalPages: 0,
        currentPage: 1,
      },
      loading: false,
      eventos: {},
      descargando: [],
      filters: {
        client: '',
        phase: '',
      },
      debouncedBuscarPams: null,
    }
  },
  computed: {
    ordenReferencia() {
      const nombre = this.pam?.data?.[0]?.Servicio?.Cotizacione?.name;
      return (typeof nombre === 'string' && nombre.trim())
        ? nombre.trim()
        : "";
    },
  },
  methods: {
    getProgressWidth(dias) {
      return `${(dias / 45) * 100}%`; // Escala proporcional
    },
    getProgressBarClass(dias) {
      if (dias <= 15) return 'bg-success';
      if (dias <= 30) return 'bg-warning';
      return 'bg-danger';
    },
    handleClickPAM(id){
      const backPath = this.$route.fullPath || `/orden-detalle/${this.$route.params.id}`;
      localStorage.setItem("pamDetalleBackLink", backPath);
      this.$router.push({
        path: `pam/${id}`,
        query: { back: backPath },
      });

    },
    goToHome() {
      const fromQuery = this.$route.query?.from;
      const fromStorage = localStorage.getItem("ordenDetalleBackLink");
      const target = fromQuery || fromStorage || "/home";
      this.$router.push(target);
    },
    orderTransitionStyle(index) {
      const delay = Math.min(index * 35, 210);
      return { transitionDelay: `${delay}ms` };
    },
    handleClientInput() {
      this.debouncedBuscarPams();
    },
    handlePhaseInput() {
      this.debouncedBuscarPams();
    },
    async obtenerPams(id, page = 1) {
      this.loading = true;
      try {
        const response = await axiosInstance.get('/pam/index',{
          params: {
            id: this.$route.params.id,
            page: page,
            cliente_nombre: this.filters.client,
            fase: this.filters.phase,
          }
        });
        this.pam = {
          data: response.data.data,
          totalItems: response.data.totalItems,
          totalPages: response.data.totalPages,
          currentPage: response.data.currentPage,
        };
        
        // Guardar página actual en localStorage
        localStorage.setItem('paginaActual'+this.$route.params.id, this.pam.currentPage);
      
        this.eventos = response.data.eventos;
      } catch (error) {
        console.error('Error al obtener datos del usuario:', error);
      } finally{
        this.loading = false;
      }
    },
    getDiasTranscurridos(servicio) {
      if (!servicio?.createdAt) return "Fecha no válida";

      const inicio = new Date(servicio.createdAt);
      const finBase =
        servicio.estatus === 2
          ? this.getUltimaActualizacion(servicio) || new Date()
          : new Date();

      const fin = new Date(finBase);

      // Normalizar a medianoche local
      inicio.setHours(0, 0, 0, 0);
      fin.setHours(0, 0, 0, 0);

      const diffMs = fin - inicio;
      const diffDays = Math.round(diffMs / 86400000);

      return Math.max(0, diffDays);
    },
    changePage(page) {
      if (page >= 1 && page <= this.pam.totalPages) {
        this.obtenerPams(this.$route.params.id, page);
      }
    },
    formatFecha(fechaIso) {
      const opciones = { day: 'numeric', month: 'long', year: 'numeric' };
      const fecha = new Date(fechaIso);
      return fecha.toLocaleDateString('es-MX', opciones);
    },
    formatearRangoHoras(inicio, fin) {
      const formatoHora = fecha => {
        const hora = new Date(fecha).getUTCHours().toString().padStart(2, '0');
        const minuto = new Date(fecha).getUTCMinutes().toString().padStart(2, '0');
        return `${hora}:${minuto}`;
      };

      return `${formatoHora(inicio)} a ${formatoHora(fin)} hrs.`;
    },
    formatearHora(hora) {
      const fecha = new Date(hora);
      const hh = fecha.getUTCHours().toString().padStart(2, '0');
      const mm = fecha.getUTCMinutes().toString().padStart(2, '0');
      return `${hh}:${mm} hrs.`;
    },
    formatFechaHora(fechaIso) {
      if (!fechaIso) return 'Sin fecha';
      const fecha = new Date(fechaIso);
      const opcionesFecha = { day: 'numeric', month: 'short', year: 'numeric' };
      const opcionesHora = { hour: '2-digit', minute: '2-digit' };
      return `${fecha.toLocaleDateString('es-MX', opcionesFecha)}, ${fecha.toLocaleTimeString('es-MX', opcionesHora)}`;
    },
    getUltimaActualizacion(pam) {
      return pam?.Servicio?.updatedAt || pam?.updatedAt || pam?.Servicio?.createdAt || null;
    },
    getCumplimiento(pam) {
      const docs = pam?.Servicio?.servicios_documentos;
      if (Array.isArray(docs) && docs.length) {
        let aceptados = 0;
        let revision = 0;
        let rechazados = 0;
        let pendientes = 0;

        docs.forEach(doc => {
          const estado = Number(doc?.estatus ?? doc?.status ?? doc?.estado);
          if (estado === 2) aceptados += 1;
          else if (estado === 1) revision += 1;
          else if (estado === 0) pendientes += 1;
          else if (estado === 3) rechazados += 1;
          else rechazados += 1;
        });

        return { aceptados, revision, rechazados, pendientes, total: docs.length };
      }

      const raw =
        pam?.cumplimiento ||
        pam?.Servicio?.cumplimiento ||
        pam?.cumplimiento_data ||
        pam?.Servicio?.cumplimiento_data ||
        {};
      const aceptados = Number(raw.aceptados ?? raw.aceptado ?? raw.aprobados ?? 0);
      const revision = Number(raw.revision ?? raw.en_revision ?? raw.revisados ?? 0);
      const rechazados = Number(raw.rechazados ?? raw.rechazado ?? 0);
      const pendientes = Number(raw.pendientes ?? raw.pendiente ?? 0);
      const total = aceptados + revision + rechazados + pendientes;
      return { aceptados, revision, rechazados, pendientes, total };
    },
    getCumplimientoSegment(pam, key) {
      const c = this.getCumplimiento(pam);
      if (!c.total) return '0%';
      const value = c[key] || 0;
      return `${Math.round((value / c.total) * 100)}%`;
    },
    getCumplimientoResumen(pam) {
      const c = this.getCumplimiento(pam);
      if (!c.total) return '0/0 Aceptados (0%)';
      const porcentaje = Math.round((c.aceptados / c.total) * 100);
      return `${c.aceptados}/${c.total} Aceptados (${porcentaje}%)`;
    },
    getObservacionesPendientes(pam) {
      const docs = pam?.Servicio?.servicios_documentos;
      if (Array.isArray(docs) && docs.length) {
        let pendientes = 0;
        docs.forEach((doc) => {
          const visto = doc?.visto;
          const esPendiente =
            visto === true || visto === 1 || Number(visto) === 1;
          if (esPendiente) pendientes += 1;
        });
        return pendientes;
      }
      const pendientesRaw =
        pam?.observaciones_pendientes ??
        pam?.Servicio?.observaciones_pendientes ??
        pam?.observacionesPendientes ??
        pam?.Servicio?.observacionesPendientes;
      const pendientes = Number(pendientesRaw);
      return Number.isFinite(pendientes) ? pendientes : 0;
    },
    getObservacionesTexto(pam) {
      const pendientes = this.getObservacionesPendientes(pam);
      if (pendientes > 0) return `${pendientes} pendientes`;
      const docs = pam?.Servicio?.servicios_documentos;
      if (Array.isArray(docs) && docs.length) {
        return "Sin observaciones";
      }
      const obs = pam?.observaciones ?? pam?.Servicio?.observaciones;
      if (typeof obs === 'string' && obs.trim()) return obs;
      return 'Sin observaciones';
    },
    getFaseLabel(pam) {
      const raw = pam.Servicio.estatus;
      const fase = Number(raw);
      if (fase === 0) return 'Recolección de documentos';
      if (fase === 1) return 'Revisión de campo';
      if (fase === 2) return 'Descargar programa interno';
      return 'SIN FASE';
    },
    async descargarInvitacion(curso, index) {
      try {
        this.$set(this.descargando, index, true);
        const response = await axiosInstance.get('/pam/generarInvitacion', {
          params: {
            fecha: this.formatFecha(curso.start) ,
            hora: this.formatearRangoHoras(curso.start, curso.end),
            curso: curso,
            cotizacion: curso.cotizacion_id
          },
          responseType: 'blob' // Muy importante para recibir binario
        });

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'invitacion.png');
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        if (error.response?.status === 400 && error.response?.data?.error) {
          this.flashMessage.error({message: '[ERROR]: No es posible obtener la imagen de la convocatoria, intenta más tarde. Si el problema persiste comunicate con tu inspector.'});
        } else {
          this.flashMessage.error({message: '[ERROR]: Ocurrio un error inesperado al descargar la convocatoria. Si el problema persiste comunicate con tu inspector.'});
        }
        console.error('Error al obtener la invitación:', error);
      }
        this.$set(this.descargando, index, false);
    }
  },
  created() {
    this.debouncedBuscarPams = debounce(() => {
      this.obtenerPams(this.$route.params.id, 1);
    }, 300);
  },
  mounted() {
    const fromQuery = this.$route.query?.from;
    if (fromQuery) {
      localStorage.setItem("ordenDetalleBackLink", fromQuery);
    }
    const paginaGuardada = Number(localStorage.getItem('paginaActual'+this.$route.params.id)) || 1;
    this.obtenerPams(this.$route.params.id, paginaGuardada)
  },
  beforeDestroy() {
    if (this.debouncedBuscarPams?.cancel) {
      this.debouncedBuscarPams.cancel();
    }
  },
};
</script>

<style>

.orden-main-wrap {
  width: 100%;
}

.orden-wide-container {
  width: 100%;
  max-width: 1500px;
  padding-left: 20px;
  padding-right: 20px;
}

.orden-head {
  text-align: left;
  margin-bottom: 12px;
}

.progress {
  height: 20px;
  border-radius: 10px;
}
.progress-bar {
  transition: width 0.5s ease-in-out, background-color 0.5s ease-in-out;
  font-size: 12px;
}
.text-req{
  font-weight: 500;
  font-size: 15px;
  display: -webkit-box; /* Establece un contenedor flexible con soporte de líneas múltiples */
  -webkit-box-orient: vertical; /* Orientación de las cajas (vertical en este caso) */
  -webkit-line-clamp: 4; /* Número máximo de líneas */
  overflow: hidden; /* Oculta el texto que excede el límite de líneas */
  text-overflow: ellipsis; /* Agrega "..." al final del texto truncado */
}

.info{
  display: flex;
  align-items: center;
}

.orden-ref-line {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  gap: 10px;
  font-size: 13px;
  letter-spacing: 0.05em;
  text-align: left;
  margin-bottom: 1rem;
}

.orden-ref-muted {
  color: #92a2b8;
  font-weight: 600;
}

.orden-ref-link {
  color: #92a2b8;
  font-weight: 600;
  cursor: pointer;
}

.orden-ref-link:hover {
  color: #0f2f5f;
}

.orden-ref-sep {
  color: #9cafc7;
  font-weight: 700;
  transform: translateY(-1px);
}

.orden-ref-strong {
  color: #0f2f5f;
  font-weight: 800;
}

.orden-title {
  margin: 0;
  font-size: 56px;
  line-height: 1.05;
  color: #101e3d;
  font-weight: 800;
  text-align: left;
}

.visitas-title-header {
  margin: 26px 0 0;
  font-size: 32px;
  line-height: 1.1;
  color: #1f6a2f;
  font-weight: 800;
  text-align: left;
}

.visitas-title-header--desktop {
  display: block;
}

.visitas-title-header--mobile {
  display: none;
}

.orders-fade-enter-active {
  transition: opacity 0.24s ease, transform 0.24s ease;
}

.orders-fade-enter {
  opacity: 0;
  transform: translateY(8px);
}

.orders-fade-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
  position: relative;
}

.orders-fade-leave-to {
  opacity: 0;
  transform: translateY(-6px);
}

@media (max-width: 768px) {
  .info{
    display: block;
  }

  .progress{
    margin-top: 4px;
  }

  .orden-title {
    font-size: 36px;
  }

  .visitas-title-header {
    margin-top: 6px;
    font-size: 28px;
  }

  .visitas-title-header--desktop {
    display: none;
  }

  .visitas-title-header--mobile {
    display: block;
  }

}

.curso-card {
  border-left: 4px solid #28a745 !important; /* Verde para distinguir cursos */
  background-color: #f8fff8; /* Un fondo suave para diferenciar */
}

.servicio-card {
  border-left: 4px solid #2863a7 !important; /* Verde para distinguir cursos */
  background-color: #f8fff8; /* Un fondo suave para diferenciar */
}

@keyframes bounce-once {
  0%   { transform: scale(1); }
  30%  { transform: scale(1.1); }
  60%  { transform: scale(0.95); }
  100% { transform: scale(1); }
}

.bounce-once {
  animation: bounce-once 0.7s ease-in-out;
  background-color: orange !important;
}

.pam-card {
  border-radius: 14px;
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;
  border: 1px solid #e3e8f0 !important;
  background: #ffffff;
  box-shadow: 0 8px 20px rgba(9, 47, 86, 0.06) !important;
  border-left: 4px solid #e3e8f0 !important;
}

.pam-card:hover {
  transform: translateY(-2px);
  border-color: #bfc7d1 !important;
  border-left-color: #0f4c96 !important;
  box-shadow: 0 12px 24px rgba(9, 47, 86, 0.12) !important;
}

.pam-card__body {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
}

.pam-card__block {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.pam-card__meta {
  width: 100%;
}

.pam-card__muted {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #8a9bb2;
}

.pam-card__title {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #10223f;
  line-height: 1.25;
}

.pam-card__badge {
  align-self: flex-start;
}

.pam-card__progress {
  width: 100%;
  padding: 12px 0;
  border-top: 1px solid #eef2f7;
}

.pam-card__label {
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #7b8aa3;
}

.pam-card__value {
  font-size: 12px;
  font-weight: 700;
  color: #1b6f3b;
}

.pam-card__progressbar {
  height: 10px;
  border-radius: 10px;
  background-color: #edf1f7;
}

.pam-card__progressbar .progress-bar {
  border-radius: 10px;
}

.pam-card__stats {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
  margin-top: 10px;
}

.pam-card__stat-label {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #8a9bb2;
}

.pam-card__stat-value {
  font-size: 13px;
  font-weight: 700;
  color: #24385a;
}

.pam-card__action {
  width: 100%;
  align-items: flex-start;
  gap: 8px;
}

.pam-card__pill {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 4px 12px;
  border-radius: 999px;
  background-color: #fff7e6;
  color: #b56a00;
  border: 1px solid #ffe3b1;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.pam-card__btn {
  align-self: flex-start;
  font-weight: 700;
}

@media (min-width: 992px) {
  .pam-card__body {
    flex-direction: row;
    align-items: center;
    padding: 20px 24px;
    gap: 24px;
  }

  .pam-card__meta {
    flex: 0 0 22%;
  }

  .pam-card__progress {
    flex: 1 1 auto;
    width: auto;
    padding: 0 20px;
    border-top: none;
    border-bottom: none;
    border-left: 1px solid #eef2f7;
  }

  .pam-card__action {
    width: 24%;
    align-items: flex-start;
  }
}

@media (max-width: 575px) {
  .pam-card__title {
    font-size: 14px;
  }

  .pam-card__stats {
    grid-template-columns: 1fr;
  }
}

.pam-card__segmented {
  display: flex;
  height: 12px;
  border-radius: 999px;
  overflow: hidden;
  background-color: #edf1f7;
}

.pam-card__segment {
  height: 100%;
}

.pam-card__segment--success {
  background-color: #28a745;
}

.pam-card__segment--review {
  background-color: #2f80ed;
}

.pam-card__segment--danger {
  background-color: #dc3545;
}

.pam-card__segment--pending {
  background-color: #c9d2e3;
}

</style>
